import useBaseIndex from "../../base/hooks/useBaseIndex"
import { IndexPaymentResponseSchema } from "../response/IndexPaymentResponse"

const API_VERSION = "v3";

interface IndexPaymentProps {
    filters?: { [key: string]: any };
    search?: string;
    paginate?: number;
    page?: number;
    [key: string]: any;
}

const useIndexPayment = (query: IndexPaymentProps) =>
    useBaseIndex({
        ...query,
        queryKey: "payment-list",
        endpoint: `${API_VERSION}/payment`,
        schema: IndexPaymentResponseSchema,
    });

export default useIndexPayment;